module.exports = __webpack_public_path__ + "img/Fake_Video-3.6d1f9e66.jpg";